import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DataState {
  currentYear: any;
  districts: any[];
  regions: any[];
  selectedFilters: {
    district?: number;
    region?: number;
    schoolLevel?: number;
    schoolType?: number;
  };
}

const initialState: DataState = {
  currentYear: null,
  districts: [],
  regions: [],
  selectedFilters: {},
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setCurrentYear: (state, action: PayloadAction<any>) => {
      state.currentYear = action.payload;
    },
    setDistricts: (state, action: PayloadAction<any[]>) => {
      state.districts = action.payload;
    },
    setRegions: (state, action: PayloadAction<any[]>) => {
      state.regions = action.payload;
    },
    setSelectedFilters: (state, action: PayloadAction<any>) => {
      state.selectedFilters = { ...state.selectedFilters, ...action.payload };
    },
    clearFilters: (state) => {
      state.selectedFilters = {};
    },
  },
});

export const { 
  setCurrentYear, 
  setDistricts, 
  setRegions, 
  setSelectedFilters, 
  clearFilters 
} = dataSlice.actions;

export default dataSlice.reducer;